export default __webpack_public_path__ + "static/low-fi-light-76e5c8f0868f3300741e592f22c6b442800ed20f64e03d60874505c66475cbfa.png";